// extracted by mini-css-extract-plugin
export default {"secret__wrapper":"Managers_secret__wrapper__7tLiR","secret__wrapperError":"Managers_secret__wrapperError__awKRg"};